export const old_lead_status = [
  { data: "Select Lead Status", value: "" },
  { data: "Upcoming Discovery", value: "UPCOMING_DISCOVERY" },
  { data: "Discovery Followup", value: "DISCOVERY_FOLLOWUP" },
  { data: "Urgent", value: "URGENT" },
  { data: "Expert Mapping", value: "EXPERT_BOOKING" },
  { data: "Followup On Hold", value: "FOLLOWUP_HOLD" },
  { data: "Reschedule", value: "RESCHEDULE" },
  { data: "First Followup", value: "DAY1_FIRST" },
  { data: "Second Followup", value: "DAY1_SECOND" },
  { data: "Third Followup", value: "DAY2" },
  { data: "Final Followup", value: "DAY3" },
  { data: "Monthly Followup", value: "MONTHLY" },
  { data: "Booked", value: "BOOKED" },
  { data: "Subscribed", value: "SUBSCRIBED" },
  { data: "Workshop", value: "WORKSHOP" },
  { data: "Call Not Picked", value: "TEXT_SCR" },
  { data: "Dead", value: "DEAD" },
  { data: "B2C Workshop Leads", value: "B2C_WORKSHOP_LEADS" },
  { data: "Subscribed 2", value: "SUBSCRIBED2" },
  { data: "Subscribed 3", value: "SUBSCRIBED3" },
  { data: "AESS Upcoming Request", value: "AESS_UPCOMING_REQUEST" },
  { data: "AESS Expert Mapping", value: "AESS_EXPERT_MAPPING" },
  { data: "Corporate Leads", value: "CORPORATE_LEADS" },
  { data: "Email Marketing", value: "EMAIL_MARKEING" },
  { data: "Web Anxiety Assessment", value: "WEB_ASSESS_ANXIETY" },
  { data: "Web Depression Assessment", value: "WEB_ASSESS_DEPRESSION" },
  { data: "Web Self-esteem Assessment", value: "WEB_ASSESS_SELFESTEEM" },
  { data: "Web Psychological wellness Assessment", value: "WEB_ASSESS_PW" },
  { data: "Web Communication Assessment", value: "WEB_ASSESS_CSI" },
  { data: "Web Oxford Assessment", value: "WEB_ASSESS_OHQ" },
  { data: "Web Subscription", value: "WEB_SUBSCRIPTION" },
];

export const new_lead_status = [
  { data: "Select Lead Status", value: "" },
  { data: "Upcoming", value: "UPCOMING" },
  // { data: "Upcoming", value: "DISCOVERY_FOLLOWUP" },
  { data: "Rescheduled", value: "RESCHEDULE" },
  { data: "Expert Not Assigned", value: "EXPERT_NOTASSIGNED" },
  { data: "Expert Assigned", value: "EXPERT_ASSIGNED" },
  // { data: "Expert Assigned", value: "DAY1_SECOND" },
  // { data: "Expert Assigned", value: "DAY2" },
  // { data: "Expert Assigned", value: "DAY3" },
  // { data: "Expert Assigned", value: "MONTHLY" },
  { data: "Booked", value: "BOOKED" },
  { data: "Subscribed", value: "SUBSCRIBED" },
  { data: "Not Answered", value: "TEXT_SCR" },
  { data: "Ignore", value: "IGNORE" },
  // { data: "Ignore", value: "WORKSHOP" },
  // { data: "Ignore", value: "FOLLOWUP_HOLD" },
  // { data: "Ignore", value: "EXPERT_BOOKING" },
  // { data: "Ignore", value: "URGENT" },
  // { data: "Ignore", value: "B2C_WORKSHOP_LEADS" },
  // { data: "Ignore", value: "SUBSCRIBED2" },
  // { data: "Ignore", value: "SUBSCRIBED3" },
  // { data: "Ignore", value: "AESS_UPCOMING_REQUEST" },
  // { data: "Ignore", value: "AESS_EXPERT_MAPPING" },
  // { data: "Ignore", value: "CORPORATE_LEADS" },
  // { data: "Ignore", value: "EMAIL_MARKEING" },
  // { data: "Ignore", value: "WEB_ASSESS_ANXIETY" },
  // { data: "Ignore", value: "WEB_ASSESS_DEPRESSION" },
  // { data: "Ignore", value: "WEB_ASSESS_SELFESTEEM" },
  // { data: "Ignore", value: "WEB_ASSESS_PW" },
  // { data: "Ignore", value: "WEB_ASSESS_CSI" },
  // { data: "Ignore", value: "WEB_ASSESS_OHQ" },
  // { data: "Ignore", value: "WEB_SUBSCRIPTION" }
];


export const lead_status = [
  { data: "Select Lead Status", value: "" },
  ...[
    "UPCOMING_DISCOVERY",
    "DISCOVERY_FOLLOWUP",
    "RESCHEDULE",
    "EXPERT_NOTASSIGNED",
    "DAY1_FIRST",
    "DAY1_SECOND",
    "DAY2",
    "DAY3",
    "MONTHLY",
    "BOOKED",
    "SUBSCRIBED",
    "TEXT_SCR",
    "DEAD",
    "WORKSHOP",
    "FOLLOWUP_HOLD",
    "EXPERT_BOOKING",
    "URGENT",
    "B2C_WORKSHOP_LEADS",
    "SUBSCRIBED2",
    "SUBSCRIBED3",
    "AESS_UPCOMING_REQUEST",
    "AESS_EXPERT_MAPPING",
    "CORPORATE_LEADS",
    "EMAIL_MARKEING",
    "WEB_ASSESS_ANXIETY",
    "WEB_ASSESS_DEPRESSION",
    "WEB_ASSESS_SELFESTEEM",
    "WEB_ASSESS_PW",
    "WEB_ASSESS_CSI",
    "WEB_ASSESS_OHQ",
    "WEB_SUBSCRIPTION",
  ].map((value) => {
    let data = "";

    if (["UPCOMING_DISCOVERY", "DISCOVERY_FOLLOWUP"].includes(value)) {
      data = "Upcoming";
    } else if (value === "RESCHEDULE") {
      data = "Rescheduled";
    } else if (value === "EXPERT_NOTASSIGNED") {
      data = "Expert Not Assigned";
    } else if (
      ["DAY1_FIRST", "DAY1_SECOND", "DAY2", "DAY3", "MONTHLY"].includes(value)
    ) {
      data = "Expert Assigned";
    } else if (value === "BOOKED") {
      data = "Booked";
    } else if (value === "SUBSCRIBED") {
      data = "Subscribed";
    } else if (value === "TEXT_SCR") {
      data = "Not Answered";
    } else {
      data = "Ignore";
    }

    return { data, value };
  }),
];


export const getLeadName = (leadStatus: string) => {
  const leadObj: any = new_lead_status.find((el: any) => el.value === leadStatus);
  const temp = leadObj?.data || "";
  return temp;
};

export const getOldLeadName = (leadStatus: string) => {
  const leadObj: any = old_lead_status.find((el: any) => el.value === leadStatus);
  const temp = leadObj?.data || "";
  return temp;
};
